import { useEffect, useState, createContext } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./components/home/home";
import Landingpage from "./components/authentication/landing-page/landing-page";
import CreateAccount from "./components/authentication/create-account/create-account";
import ForgotPassword from "./components/authentication/forgot-password.js/forgot-password";

export const IsAuthContext = createContext();

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const storedAuthStatus = localStorage.getItem("isAuthenticated");
    return storedAuthStatus === "true"; // Convert string to boolean
  });

  useEffect(() => {
    localStorage.setItem("isAuthenticated", isAuthenticated ? "true" : "false"); // Store as string
  }, [isAuthenticated]);

  const [userData, setUserData] = useState(() => {
    const storedUserData = localStorage.getItem("userData");
    return storedUserData || ""; // Set as empty string
  });

  useEffect(() => {
    localStorage.setItem("userData", userData); // Store userData as a string
  }, [userData]);

  return (
    <div className="App">
      <IsAuthContext.Provider
        value={[isAuthenticated, setIsAuthenticated, userData, setUserData]}
      >
        <Routes>
          <Route
            path="/home"
            element={
              // <PrivateRoute isAuthenticated={isAuthenticated}>
              <Home />
              // </PrivateRoute>
            }
          />
          <Route path="/" element={<Landingpage />} />
          <Route path="/create-account" element={<CreateAccount />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
        </Routes>
      </IsAuthContext.Provider>
    </div>
  );
}

export default App;
